import styled from '@emotion/styled'
import _ from 'lodash'
import {
  IntegrationFormManager,
  IntegrationFormField,
  IntegrationNameBuilder,
  AccountSelectionBuilder,
  CustomFieldBuilder,
} from '../components'
import { FileFormPartial } from '../file-form-partial'
import { BoxFolderSelection } from './components/box-folder-selection'

const FullWidth = styled.div`
  width: 100%;
`

export function BoxPushV2({ integration, assignment }) {
  const integrationNameField = new IntegrationNameBuilder().placement(1).build()
  const accountSelectionField = new AccountSelectionBuilder()
    .placement(2)
    .resetOnChange(true)
    .build()
  const folderSelectionField = new CustomFieldBuilder()
    .placement(3)
    .customField(<BoxFolderSelection assignment={assignment} />)
    .build()
  const fieldMapping = new CustomFieldBuilder()
    .placement(4)
    .customField(
      <FileFormPartial
        integration={integration}
        assignment={assignment}
        shouldIncludeName={false}
        enablePerTarget={true}
      />,
    )
    .build()

  const BoxPushV2FormFields: IntegrationFormField[] = [
    integrationNameField,
    accountSelectionField,
    folderSelectionField,
    fieldMapping,
  ]

  return (
    <FullWidth>
      <IntegrationFormManager
        integrationType="box-push-v2"
        integrationAssignment={assignment}
        integrationFields={BoxPushV2FormFields}
      />
    </FullWidth>
  )
}
